import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Login } from '@itds/components/index.js';

import { RECAPTCHA_SITE_KEY } from '@/config';

import Api from '@carrier/utils/Api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (Cookies.get('control-room-c')) {
      navigate('/carriers');
    }
  });

  const login = data => {
    setLoading(true);

    Api.login(data)
      .then(({ headers }) => {
        Cookies.set('control-room-c', headers['access-token']);
        Cookies.set('control-room-cr', headers['refresh-token']);
        Cookies.set('email', data.email);

        window.location.reload();
      })
      .catch(() => {
        setError('Invalid email or password.');
        setLoading(false);
      });
  };

  return (
    <Login
      error={error}
      loading={loading}
      onLogin={login}
      siteKey={RECAPTCHA_SITE_KEY}
      title='Carrier Admin'
    />
  );
};

export default AdminLogin;
